import { useId } from 'react';

import { paths } from '@farmersdog/constants';
import { Link, ResponsiveText } from '@farmersdog/corgi';
import { GridContainer } from '@farmersdog/corgi-x';

import { TextTypeRenderer } from '../../../components/TextTypeRenderer';
import { SliceType, EmailFormSlice, isSliceOfType } from '../../../slices';

import styles from './FreshDogFood.css';

import type { BreedDocument } from '../types';

export interface FreshDogFoodProps {
  document: BreedDocument;
}

export function FreshDogFood({ document }: FreshDogFoodProps) {
  const id = useId();
  const emailFormSlice = document.data.body.find(
    isSliceOfType(SliceType.EmailFormSlice)
  );

  const linkCopy = emailFormSlice
    ? emailFormSlice.primary.formCta
    : 'Start Feeding Fresh';

  return (
    <section aria-labelledby={id} className={styles.section}>
      <GridContainer className={styles.grid}>
        <ResponsiveText
          className={styles.title}
          color="kale-3"
          variant="heading-1"
          as="h1"
          id={id}
        >
          Fresh Food for {document.data.title}
        </ResponsiveText>
        <div className={styles.description}>
          <TextTypeRenderer nodes={document.data.description} />
        </div>
        {emailFormSlice && (
          <div className={styles.form}>
            <EmailFormSlice slice={emailFormSlice} />
          </div>
        )}
        <div className={styles.cta}>
          <Link asButton className={styles.buttonLink} href={paths.PATH_SIGNUP}>
            {linkCopy}
          </Link>
        </div>
      </GridContainer>
    </section>
  );
}
